module.exports = __webpack_public_path__ + "static/media/14.174b681a.JPG";